module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_epopcon.7b3866527e8d3178cedb29ffcd8ea9f7.png";